import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {MatInput} from '@angular/material/input';

@Component({
  selector: 'app-time-picker-padrao',
  standalone: true,
  imports: [
    MatInput
  ],
  templateUrl: './time-picker-padrao.component.html',
  styleUrl: './time-picker-padrao.component.css'
})
export class TimePickerPadraoComponent implements OnChanges {

  @Output() envioHorarioSelecionado = new EventEmitter<any>();

  tempoRaw = '';

  @Input() tempo = '';
  @Input() labelExtra = '';
  @Input() disabled = false;
  @Input() alinhamentoLateral = false;

  digitos: string[] = [];


  ngOnChanges(changes: SimpleChanges) {
    if(changes['tempo']){
      if(!this.tempo){
        this.tempo = '';
      }
    }
  }

  receberValor(event: any) {
    const input = event.target as HTMLInputElement;
    const isBackspace = event.inputType === 'deleteContentBackward';

    if (isBackspace) {
      this.digitos.pop();
    } else {
      const novoNumero = input.value.replace(/\D/g, '').slice(-1);

      if (novoNumero) {
        this.digitos.push(novoNumero);
        if (this.digitos.length > 4) {
          this.digitos.shift();
        }
      }
    }

    const padded = this.digitos.join('').padStart(4, '0');
    this.tempoRaw = padded;

    const horas = padded.slice(0, 2);
    const minutos = padded.slice(2, 4);
    const formatado = `${horas} : ${minutos}`;

    this.tempo = formatado;
    input.value = formatado;

    this.envioHorarioSelecionado.emit(this.tempo);
  }

}
